import { Component, input } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { WjInputModule } from '@grapecity/wijmo.angular2.input'

import { ListItem } from '../../../../shared'
import { FuelRequest } from '../fuel-request.model'

@Component({
    selector: 'app-fuel-request-form',
    templateUrl: './fuel-request-form.component.html',
    styleUrls: ['./fuel-request-form.component.css'],
    standalone: true,
    imports: [FormsModule, WjInputModule],
})
export class FuelRequestFormComponent {
    fuelRequest = input.required<FuelRequest>()
    jobOptions = input<ListItem<string>[]>([])
    employeeOptions = input<ListItem<number>[]>([])
    equipmentOptions = input<ListItem<string>[]>([])

    fuelLevelOptions: ListItem<string>[] = [
        new ListItem('', 'Select...'),
        new ListItem('1/2', '1/2'),
        new ListItem('1/4', '1/4'),
        new ListItem('Empty', 'Empty'),
    ]

    fuelTypeOptions: ListItem<string>[] = [
        new ListItem('', 'Select...'),
        new ListItem('Diesel On-road', 'Diesel On-road'),
        new ListItem('Diesel Off-road', 'Diesel Off-road'),
    ]

    equipmentRunningOptions: ListItem<string>[] = [
        new ListItem('', 'Select...'),
        new ListItem('Yes', 'Yes'),
        new ListItem('No', 'No'),
    ]

    priorityLevelOptions: ListItem<string>[] = [
        new ListItem('', 'Select...'),
        new ListItem('Low', 'Low'),
        new ListItem('Normal', 'Normal'),
        new ListItem('Urgent', 'Urgent'),
    ]
}
